// store/modules/digitalizations/actions.js
import DigitalizationApi from "../../../api/modules/DigitalizationApi";

export const searchDigitalizations = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await DigitalizationApi.searchDigitalizations(context, data);
  } catch (error) {
    console.error("Error al buscar digitalizaciones:", error);
    throw error;
  }
};

export const exportDigitalizationsExcel = async ({commit}, payload) => {
  try {
    const {context, filters} = payload;
    return await DigitalizationApi.exportDigitalizationsExcel(context, filters);
  } catch (error) {
    console.error("Error al exportar Excel de digitalizaciones:", error);
    throw error;
  }
};


export const exportDigitalizationsPdf = async ({commit}, payload) => {
  try {
    const {context, filters} = payload;
    return await DigitalizationApi.exportDigitalizationsPdf(context, filters);
  } catch (error) {
    console.error("Error al exportar PDF de digitalizaciones:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/digitalizations/actions.js